import styled from 'styled-components';
import colors from '../../assets/styles/colors';
import { screens } from '../../assets/styles/screens';

export const LoginContainer = styled.main`
  height: 100%;
  display: grid;
  grid-template-columns: minmax(720px, 40%) 1fr;
  overflow: hidden;
  background: ${colors.white};
`;

export const LoginColumn = styled.div`
  height: 100%;
  
  &:first-child {
    height: 100%;
    padding: 60px;
    position: relative;

    &:before {
      content: '';
      top: 0;
      left: -100px;
      min-width: 718px;
      width: 90%;
      height: 100%;
      position: absolute;
      transform: skewX(10deg);
      background: transparent;
      box-shadow: 0px 5px 10px rgba(38, 39, 96, 0.3);
      border-top-right-radius: 16px;
      border-bottom-right-radius: 16px;
      background: ${colors.bgGray};
    }
  }
`;

export const LoginOverlay = styled.div`
  height: 100%;
  position: relative;
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const LoginLogo = styled.img`
  width: 269px;
`;

export const LoginImage = styled.img`
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  max-width: 780px;

  @media ${screens.desktopMd} {
    max-width: 520px;
  }

  @media ${screens.desktopSm} {
    max-width: 480px;
  }
`;

export const LoginhighlightedText = styled.span`
  color: ${colors.bgSecondary};
`;

export const LoginText = styled.div`
  width: 100%;
  max-width: 420px;
`;

export const LoginButton = styled.button`
  border: 1px solid ${colors.bgSecondaryLight};
  background: ${colors.bgSecondary};
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  padding: 16px 32px;
  width: 301px;
  margin-top: 40px;
  transition: ease-in-out .2s;

  &:hover {
    background: ${colors.bgSecondaryHover};
    box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const LoginCopyright = styled.div`
  
`;

export const LoginCopyrightTextLine = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: ${colors.textPrimary};
`;

export const LoginCopyrightImage = styled.img`
  margin-bottom: 5px;
`;
